import { render, staticRenderFns } from "./SamclickInput.vue?vue&type=template&id=f2d21b10&"
import script from "./SamclickInput.vue?vue&type=script&lang=ts&"
export * from "./SamclickInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports